<div class="search-menu-folder-settings">
  <button
    mat-icon-button
    color="primary"
    class="search-menu-folder-settings__button"
    [matMenuTriggerFor]="folderMenu"
    [matMenuTriggerRestoreFocus]="false"
    (menuOpened)="toggleMenu = true;"
    (menuClosed)="toggleMenu = false;"
    [ngClass]="{'active': toggleMenu}"
    (click)="toggleFolderSettingMenu()"
    [matTooltip]="'TRANS__FOLDER__EDIT__TITLE_EDIT' | translate"
  >
    <mat-icon class="search-menu-folder-settings__button-setting-icon">
      folder_managed
    </mat-icon>
  </button>

  <mat-menu
    #folderMenu="matMenu"
    [overlapTrigger]="false"
    class=""
    (closed)="toggleMenu = false;"
  >
    @if (searchContainer.operationContainerDropDown?.operations) {
      <mat-list class="common-search-menu">
        @for (operation of searchContainer.operationContainerDropDown.operations; track $index) {
          <ng-container>
            <button
              mat-menu-item
              class="search-menu-folder-settings__menu-button"
              (click)="openOperation(operation)"
            >
              <i class="{{operation.menu_icon}}"></i>

              <span>
                {{ operation.menu_title | translate }}
              </span>
            </button>
          </ng-container>
        }
      </mat-list>
    }
  </mat-menu>
</div>
